module.exports = __webpack_public_path__ + "static/media/IVY-04.3d5f75ae.png";